import React, { useEffect, useState } from "react";

import Table from "react-bootstrap/Table";

import { api } from "../../services/api";

import Rodape from "../../components/Footer/rodape";
import { Menu } from "../../components/Menu";
import { Header } from "../../components/Header";
import { DashLayoutPerformance } from "../../components/DashLayoutPerformance";
import { DashLayoutGrid } from "../../components/DashLayoutGrid";

import Accordion from "react-bootstrap/Accordion";

import utf8 from "utf8";

export const PerformanceCourseOn = () => {
  const _data = JSON.parse(sessionStorage.getItem("@Auth:data"));
  let totalInfo = 0;
  let totalHoras = 0;
  let arrayTotalHoras = [];

  const [performance, setPerformance] = useState([]);
  const [pontAno, setPontAno] = useState([]);
  const performance2 = performance;
  const set = new Set(performance2);
  const arraySemDuplicados = Array.from(set);

  const PontAno = async () => {
    try {
      const httpOptions = {
        headers: {
          "Content-Type": "application/json",
          appKey:
            "obqIkpJeNu-dCivljB1zg-uq6FJz0Xwk-VkAEfvAjL1-HJaM17VkY1-AeIWq1o4Xg",
          Authorization: `Bearer ${_data.token}`,
          "Access-Token": _data.token,
        },
      };

      const res = await api.get("/pontuacao/ano", httpOptions);
      setPontAno(res.data);
    } catch (error) {
      error;
    }
  };

  useEffect(() => {
    PontAno();
    return;
  }, [setPontAno]);

  const performanceon = async () => {
    try {
      const httpOptions = {
        headers: {
          Accept: "application/json; charset=UTF-8",
          Authorization: `Bearer ${_data.token}`,
          "Access-Token": _data.token,
          appKey:
            "obqIkpJeNu-dCivljB1zg-uq6FJz0Xwk-VkAEfvAjL1-HJaM17VkY1-AeIWq1o4Xg",
        },
      };

      const res = await api.get("/performance", httpOptions);
      for (const ano in res.data) {
        performance.push(res.data[ano]);
      }
      setPerformance([...performance]);
      return;
    } catch (error) {
      error;
    }
  };

  useEffect(() => {
    performanceon();
  }, [setPerformance]);

  return (
    <>
      <Header />
      <Menu />
      <DashLayoutGrid>
        <br />
        <h3 style={{ color: "#ccc" }}>PERFORMANCE</h3>
        <hr style={{ color: "#cccc" }} />
        <h5 style={{ color: "#ccc" }}>Visualização da performance</h5>
        <hr style={{ color: "#cccc" }} />
        <br />
        <h3 style={{ color: "#F33131" }}>{_data.nome}</h3>
        <br />
        <Table striped bordered hover variant="dark" border="0" responsive="xl">
          <tbody>
            {performance?.map((item, index) => {
              return Object.entries(item).map(([ano, info]) => (
                <>
                  <br />
                  {info?.pontos?.map((ponto, index) => (
                    <>
                      <tr key={index}>
                        <td style={{ border: "none" }}>{ponto.ano}</td>

                        <td style={{ border: "none" }}>{ponto.codigo}</td>
                        <td style={{ border: "none" }}>
                          <Accordion>
                            <Accordion.Item
                              eventKey="0"
                              style={{ background: "#333333", color: "#ccc" }}
                            >
                              <Accordion.Header>
                                {utf8.decode(ponto.nome)}
                              </Accordion.Header>
                              <Accordion.Body>
                                <b>Evento:</b>{" "}
                                {ponto.categoria === "I"
                                  ? "Interno"
                                  : "Externo"}
                                <br />
                                <b>Modalidade:</b> {ponto.modalidade}
                                <br />
                                <b>Atuação:</b>{" "}
                                {ponto.atuacao === "P"
                                  ? "Participante"
                                  : "Facilitador"}
                                <br />
                                <b>Tipo:</b>
                                {ponto.tipo == "A" ? " Artigo" : ""}
                                {ponto.tipo == "E" ? " Especialização" : ""}
                                {ponto.tipo === "C"
                                  ? " Comportamental"
                                  : " Técnico"}
                                {ponto.tipo == "M" ? " Mestrado" : ""}
                                {ponto.tipo == "E" ? " Diversos" : ""}
                                {ponto.tipo == "O" ? " Outros" : ""}
                                <br />
                                <b>Período:</b>{" "}
                                {new Date(ponto.dtinicio).toLocaleDateString(
                                  "pt-BR",
                                  { timeZone: "UTC" }
                                )}{" "}
                                até{" "}
                                {new Date(ponto.dtfim).toLocaleDateString(
                                  "pt-BR",
                                  { timeZone: "UTC" }
                                )}
                                <br />
                                <b>Carga Horária:</b> {ponto.cargahoraria}h
                              </Accordion.Body>
                            </Accordion.Item>
                          </Accordion>
                        </td>
                        <td style={{ border: "none" }}>{ponto.pontuacao}pt</td>
                      </tr>
                    </>
                  ))}
                </>
              ));
            })}{" "}
          </tbody>
        </Table>
      </DashLayoutGrid>

      <DashLayoutPerformance>
        <br />
        <br />
        <h5 style={{ color: "#ccc" }}>
          PONTOS EM {new Date().getFullYear()} <hr style={{ color: "#ccc" }} />{" "}
        </h5>

        {pontAno.total > 0 ? (
          <>
            {" "}
            <h3 style={{ fontSize: "2.4rem", color: "#ffff" }}>
            {Number(pontAno.total).toFixed(1)}
            </h3>{" "}
          </>
        ) : (
          <>
            {" "}
            <h3 style={{ fontSize: "2.4rem", color: "red" }}>
            {Number(pontAno.total).toFixed(1)}
            </h3>{" "}
          </>
        )}

        <br />
        <h5 style={{ color: "#ccc" }}>RESUMO</h5>
        <hr style={{ color: "#ccc" }} />

        <Table striped bordered hover variant="dark" border="0" responsive="xl">
          <thead>
            <tr style={{ backgroundColor: "#f2f2f2" }}>
            <th>Ano</th>
              <th>Codigo</th>
              <th>Modalidade</th>
              <th>Atuação</th>
              <th>Tipo</th>
              <th>CH</th>
            </tr>
          </thead>
          <tbody>
            {performance?.map((item, index) => {
              return Object.entries(item).map(([ano, info]) => (
                
                <>
                  {info?.pontos?.sort((a, b) => a.codigo - b.codigo) // Sort the pontos array in descending order based on the ano field
  .map((ponto, index) => (
                    <tr style={{ backgroundColor: "#ffffff" }}>
                         <td>{ponto.ano}</td>
                      <td>{ponto.codigo || ponto.categoria == "Facilitador"}</td>
                      <td>{ponto.modalidade}</td>
                      <td>{ponto.atuacao === "P"
                                  ? "Participante"
                                  : "Facilitador"}</td>
                      <td>
                        {ponto.tipo == "A" ? " Artigo" : ""}
                        {ponto.tipo == "E" ? " Especialização" : ""}
                        {ponto.tipo === "C" ? " Comportamental" : " Técnico"}
                        {ponto.tipo == "M" ? " Mestrado" : ""}
                        {ponto.tipo == "E" ? " Diversos" : ""}
                        {ponto.tipo == "O" ? " Outros" : ""}
                      </td>

                      <td>{ponto.cargahoraria}h</td>                
                    </tr>
                  ))}
                </>
              ));
            })}
          </tbody>
        </Table>

{/*         {
  performance?.map((item, index) => {
    return Object.entries(item).map(([ano, info]) => (
      <>
        {info?.pontos?.map((ponto, index) => {
          totalHoras += ponto.cargahoraria;
         
        })}
        
      </>
    ));
  })
}
<p style={{ color: "#ffffff" }}>
              {" "}             
                <>TOTAL: {totalHoras}</>
             
            </p> */}
 
 

 <br /> 
        <h5 style={{ color: "#ccc" }}>DETALHES</h5>
        <hr style={{ color: "#ccc" }} />
        <Table striped bordered hover variant="dark" responsive="xl">
        <thead>
            <tr>            
            <th style={{ color: "#ccc", width: "100px" }}>Ano</th>
              <th style={{ color: "#ccc" }}>Total</th>
              <th style={{ color: "#ccc" }}>Total computado</th>
            </tr>
          </thead>
           <tbody>
                      
           {performance?.slice(0, 1).map((item, index) => {
  return Object.entries(item).map(([ano, info]) => (
    <>      
      <tr>               
        <td style={{ border: "none",  color: "#ccc" }}>{ano}</td>
        <td  style={{ color: "#ccc"  }} >{info.total}</td>
        <td  style={{ color: "#ccc" }} >{info.total_computado < 48 ? (<>{info.total_computado} </>) : (<>{info.total_computado} <h8 style={{ color: "red" }} > - Max</h8></>)}</td>
      </tr>  
    </>
  ));
})}


            </tbody>
            </Table>    


{performance?.slice(0, 1).map((item, index) => {
  return Object.entries(item).map(([ano, info]) => {
    totalInfo += info.total; // Isso irá somar o total de cada info ao totalInfo   
  });
})}
 <p style={{ color: "#ffffff" }}>
              {" "}             
                <>TOTAL: {totalInfo}</>
             
            </p>
      
  {performance.map((ponto) => {
          return (
            <p style={{ color: "#ffffff" }}>
              {" "}
              {ponto.total_geral > 0 ? (
                <>TOTAL Computado: {ponto.total_geral.toFixed(1)}</>
              ) : (
                <></>
              )}{" "}
            </p>
          );
        })}
        <br /> 

        <hr style={{ color: "#ccc" }} />
        <br /> 
        <h5 style={{ color: "#ccc" }}>CURSOS</h5>
        <hr style={{ color: "#ccc" }} />

        <Table striped bordered hover variant="dark" responsive="xl">
          <thead>
            <tr>
              <th>PRESENCIAL</th>
              <th>EAD</th>
              <th>OUTROS</th>
            </tr>
          </thead>

          <tbody>
            {performance.map((ponto, i) => {
              return (
                <>
                  <tr>
                    <td style={{ color: "#ffff" }}>
                      {ponto.total_ponto_presencial}
                    </td>
                    <td style={{ color: "#ffff" }}>{ponto.total_ponto_ead}</td>
                    <td style={{ color: "#ffff" }}>
                      {ponto.total_ponto_outros}
                    </td>
                  </tr>
                </>
              );
            })}
          </tbody>        
        </Table>
      </DashLayoutPerformance>
      <Rodape />
    </>
  );
};
